function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_146230",
  d: "M223.207,121.57a.711.711,0,0,1-.685-.611c-.981-5.421-1.517-6.4-7.1-7.141a.705.705,0,0,1,0-1.406c5.55-.74,6.272-1.776,7.1-7.1a.7.7,0,0,1,.685-.629.718.718,0,0,1,.722.611c.962,5.421,1.517,6.364,7.086,7.123a.7.7,0,0,1,.648.7.717.717,0,0,1-.648.7c-5.55.629-6.272,1.7-7.086,7.123A.72.72,0,0,1,223.207,121.57Zm7.345,3a.516.516,0,0,1-.518-.444c-.481-2.664-.333-2.775-3.238-3.238a.5.5,0,0,1-.444-.518.519.519,0,0,1,.444-.518c2.9-.462,2.757-.574,3.238-3.2a.536.536,0,0,1,.518-.481.552.552,0,0,1,.537.481c.5,2.609.315,2.7,3.238,3.2a.5.5,0,0,1,.444.518.49.49,0,0,1-.5.518c-2.868.444-2.683.555-3.182,3.2A.538.538,0,0,1,230.553,124.567Z",
  transform: "translate(-214.771 -104.678)",
  fill: "currentColor"
});

function SvgStarsGroupFillMirror(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19.889,
    viewBox: "0 0 20 19.889",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarsGroupFillMirror);
export default __webpack_public_path__ + "static/media/stars-group-fill-mirror.d96150b5.svg";
export { ForwardRef as ReactComponent };